
/* eslint-disable max-len */

export const MARKETS_TITLES = {
  10: "US 10 Year Treasury",
  30: "UMBS 30 Year - 5.5% Coupon"
};

export const MARKETS_DESCRIPTIONS = {
  10: "Tracks the benchmark yield most commonly used to guide mortgage rate trends.",
  30: "Shows the daily price movement of 30-year mortgage bonds — a leading indicator for interest rate changes."
};

export const MARKETS_TOOLTIP_TEXTS = {
  [MARKETS_TITLES[10]]: "Most mortgage lenders track the 10-Year Treasury yield as a proxy for setting interest rates. While mortgages are typically 30-year terms, most borrowers refinance or move within 7–10 years — making the 10-year a more relevant benchmark. When the 10-year yield rises, mortgage rates often follow, and vice versa.",
  [MARKETS_TITLES[30]]: "Mortgage-backed securities (MBS) represent the actual bonds behind most 30-year fixed mortgage loans. As MBS prices go down, mortgage rates go up — and when MBS prices rise, rates tend to fall. That's because bond prices and yields move in opposite directions. Loan officers monitor MBS price movement daily to guide interest rate lock decisions."
};
